module.exports = __webpack_public_path__ + "img/Tankimage.3513ecf5.png";